import { useState } from "react";
import { layers } from "../../assets/icons";
import { useLanguageContext } from "../../context/LanguageContext";

const COLORS = {
  DIGITAL: "#F59E0B",
  FISICA: "#9747FF",
  PRESENCIAL: "#2563EB",
  ALL: "#10B981",
};

function LegendItem({ label, color }) {
  return (
    <div className="flex items-center gap-3 px-2 py-1">
      <div className="h-4 w-4 rounded-sm" style={{ backgroundColor: color }} />
      <span className="text-sm text-gray-800">{label}</span>
    </div>
  );
}

const MapLegend = () => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useLanguageContext();

  function toggleOpen() {
    setOpen((prev) => !prev);
  }

  return (
    <div id="map-legend" className="fixed right-10 bottom-36 z-30">
      <button
        onClick={toggleOpen}
        className="p-3 rounded-md bg-white text-secondary_accent_hover"
      >
        {layers}
      </button>

      <div
        className={`
          absolute flex flex-col gap-2 p-3
          -translate-x-[212px]
          bg-white rounded-lg shadow-md
          transition-all duration-500 ease-in-out
          overflow-hidden
          w-52
          ${
            isOpen
              ? "max-h-[300px] -translate-y-[160px] opacity-100"
              : "max-h-0 -translate-y-[20px] opacity-0"
          }
        `}
      >
          <LegendItem
          label={t("component", "marker", "digitalService")}
          color={COLORS.DIGITAL}
        />

        <LegendItem
          label={t("component", "marker", "physicalService")}
          color={COLORS.FISICA}
        />

        <LegendItem
          label={t("component", "marker", "localStore")}
          color={COLORS.PRESENCIAL}
        />

        <LegendItem
          label={t("component", "marker", "allStores")}
          color={COLORS.ALL}
        />
      </div>
    </div>
  );
};

export default MapLegend;
